module.exports = __webpack_public_path__ + "static/media/left-lateral-flexion.976888cc.png";